<template>
  <div class="update-pwd">
    <div class="title"><i class="el-icon-edit-outline"></i> 信息修改</div>
    <div class="user-info">
      <div class="info-bottom">
        <h4>分数/科目修改</h4>
          <div class="subject-item" v-if="userInfo.yhlb===7||userInfo.yhlb===9">
            <span>专业类别：</span>
            <el-select style="width:150px" v-model="zylb">
                <el-option :label="item" :value="item" v-for="(item,index) in zylbOptions" :key="index"></el-option>
            </el-select>
          </div>
        <div class="subject-item" style="justify-content:space-between;">
          <div>
            <span>首选科目：</span>
            <el-radio-group v-model="sxkm">
              <el-radio
              v-for="sxkm in sxkms"
              :label="sxkm.value"
              :key="sxkm.value"
              border>{{ sxkm.label }}</el-radio>
            </el-radio-group>
          </div>
          <div>
            <span>语文：</span>
            <el-input style="width:100px" v-model="ywcj" maxlength="3"></el-input>
          </div>
          <div>
            <span>数学：</span>
            <el-input style="width:100px" v-model="sxcj" maxlength="3"></el-input>
          </div>
          <div>
            <span>英语：</span>
            <el-input style="width:100px" v-model="wycj" maxlength="3"></el-input>
          </div>
          </div>

        <div class="score-panel" style="padding-bottom:0;">
          <div class="score-item">
            <span
              >文化成绩： <input type="text" v-model.number="wscore" maxlength="3"
            /></span>
            <span>专业成绩：<input type="text" v-model.number="zscore"
              maxlength="3" /></span>
          </div>
            <div>
            </div>
          <div class="subject-item">
            <span>科目修改：</span>
            <el-checkbox-group
              v-model="checked_zxkm"
              :max="2"
              @change="choose_zxkm"
            >
              <el-checkbox
                v-for="zxkm in zxkms"
                :label="zxkm.value"
                :key="zxkm.value"
                border
                >{{ zxkm.text }}</el-checkbox
              >
            </el-checkbox-group>
            <!-- <el-button
              class="store-btn"
              type="primary"
              size="medium"
              @click="updateScoreBtn"
              >确认修改</el-button
            > -->
          </div>
        </div>


                      <!-- <textarea class="specialInput" 
              style="width:806px;height:60px;resize: none;" v-model="userBz"
              ></textarea> -->
          <div class="subject-item specialSubjectItem">
            <div style="display:flex;align-items:center;">
              <div style="width:72px;">手机号：</div>
              <input class="specialInput" style="width:167px;" disabled 
              v-model="userInfo.sjhm"/>
            </div>
            <div style="display:flex;align-items:center;">
              
              <div style="width:82px;">注册卡号：</div>
              <input class="specialInput" style="width:167px;" disabled 
              v-model="userInfo.zckh"/>
            </div>
            <div style="display:flex;align-items:center;">
              
              <div style="width:92px;">是否有加分：</div>
              <el-select size="small" style="width:100px;" v-model="yfjf">
                <el-option v-for="(item,index) in jfs" :key="index"
                :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>

          </div>


          
            <!-- <el-input v-model.trim="userBz" style="width:806px;" size="small"></el-input> -->
          <div class="subject-item" style="">
            <div style="width:72px;">备注：</div>
              <input class="specialInput" style="width:806px;height:100px;" v-model="userBz"/>

          </div>

          <div class="subject-item" style="display:flex;justify-content:center;">
            <div>
              <el-button
              class="store-btn"
              type="primary"
              size="medium"
              @click="updateScoreBtn"
              >确认</el-button
            >
            </div>
          </div>

        <div class="tip-panel" style="display: flex;justify-content: center;text-align: left;font-size: 18px;">
          <div>
            <i class="el-icon-warning"></i> <span style="font-weight: bold;">提示：</span>
          </div>
          <div>
            <p>
                    <!-- 高考成绩公布后，只允许修改一次分数和再选科目,请谨慎操作！
                    <span style="color:blue;">非志愿填报期间可任意修改。</span> -->
                    1、高考成绩公布前，可任意修改所有选项;
                </p>
                <p>2、高考成绩公布后，只允许修改一次分数;</p>
                <p>
                    3、非当年高考毕业的考生在高考志愿填报期间禁止登录。
                </p>
          </div>
        </div>
      </div>
      <!-- <div class="info-bottom"></div> -->
      <!-- <h4>基本信息</h4> -->
      <!-- <div class="info-top">
        <span
          >用户名: <strong>{{ userInfo.username }}</strong></span
        >
        <span
          >首选科目: 
          <strong v-if="userInfo.sxkm===1">历史</strong>
          <strong v-if="userInfo.sxkm===2">物理</strong>
          </span
        >
        <span
          >再选科目:
          <strong v-if="userInfo.zxkma===1&&userInfo.zxkmb===2||(userInfo.zxkmb===1&&userInfo.zxkma===2)">
            政治-地理</strong>
          <strong v-if="userInfo.zxkma===1&&userInfo.zxkmb===3||(userInfo.zxkmb===1&&userInfo.zxkma===3)">
            化学-政治</strong>
          <strong v-if="userInfo.zxkma===1&&userInfo.zxkmb===4||(userInfo.zxkmb===1&&userInfo.zxkma===4)">
            政治-生物</strong>
          <strong v-if="userInfo.zxkma===2&&userInfo.zxkmb===3||(userInfo.zxkmb===2&&userInfo.zxkma===3)">
            化学-地理</strong>
          <strong v-if="userInfo.zxkma===2&&userInfo.zxkmb===4||(userInfo.zxkmb===2&&userInfo.zxkma===4)">
            地理-生物</strong>
          <strong v-if="userInfo.zxkma===3&&userInfo.zxkmb===4||(userInfo.zxkmb===3&&userInfo.zxkma===4)">
            化学-生物</strong>
          </span
        >
        <span
          >专业类别: <strong>{{ userInfo.zylb }}</strong></span
        >
        <span
          >文化成绩: <strong>{{ userInfo.wscore }}</strong></span
        >
        <span
          >专业成绩: <strong>{{ userInfo.zscore }}</strong></span
        >
        <span
          >会员卡号: <strong>{{ userInfo.zckh }}</strong></span
        >
        <span
          >卡号年度: <strong>{{ userInfo.year }}年</strong></span
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import { updateScore,getZyTypes } from "../../../api/index";
import { mapState } from "vuex";
import { zxkmList } from "../../../common/Conditions";
export default {
  name: "updateScore",
  data() {
    return {
      wscore: "", // 文化分数
      zscore: "", // 专业分数
      tip: "", // 提示信息
      sxkm:"",
      checked_zxkm: [], // 再选科目值
      zxkms: zxkmList, // 再选科目列表
      sxkms:[
        {label:"历史",value:1},
        {label:"物理",value:2}
      ],
      jfs:[
        {label:'无',value:0},
        {label:'5分',value:5},
        {label:'10分',value:10},
        {label:'20分',value:20}
      ],
      zylb:"",
      module:{},
      zylbOptions:[],
      readloadTimer:null,
      miaoshu:"",
      yfjf:0,
      ywcj:'',
      sxcj:'',
      wycj:'',
      userBz:''
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    // 修改分数
    async updateScoreBtn() {
      const zxkm = this.checked_zxkm;
      const zxkma = this.checked_zxkm[0];
      const zxkmb = this.checked_zxkm[1];
      // if (this.userInfo.gkfsxg === 2) {
      //   this.$message({
      //     type: "error",
      //     message: "抱歉，您的分数修改次数已用完，暂不可修改",
      //     duration: "2000",
      //   });
      //   return;
      // }else if (this.userInfo.gkfsxg === 11) {
      //     this.$confirm("分数修改仅剩一次机会，您确定修改吗？", "提示", {
      //       type: "warning",
      //     })
      //       .then(async () => {
      //         // const result = await updateScore(
      //         //   this.userInfo.uid,
      //         //   this.userInfo.frequency,
      //         //   this.userInfo.kl,
      //         //   this.userInfo.zylb,
      //         //   this.wscore,
      //         //   this.zscore,
      //         //   zxkm
      //         // );
      //         if (!this.wscore) {
      //     this.$message({
      //       type: "error",
      //       message: "请输入文化成绩",
      //       duration: "2000",
      //     });
      //     return;
      //         } else if (!this.zscore) {
      //           this.$message({
      //             type: "error",
      //             message: "请输入专业成绩",
      //             duration: "2000",
      //           });
      //           return;
      //         } else if (zxkm.length < 2) {
      //           this.$message({
      //             type: "error",
      //             message: "请选择两项科目",
      //             duration: "2000",
      //           });
      //           return;
      //         }else if(!this.sxkm){
      //           this.$message({
      //             type: "error",
      //             message: "请选择首选科目",
      //             duration: "2000",
      //           });
      //           return;
      //         }else if(!this.zylb){
      //           this.$message({
      //             type: "error",
      //             message: "请选择专业类别",
      //             duration: "2000",
      //           });
      //           return;
      //         }
      //         const result=await this.$http.postHttp("/users/modifyFs",{
      //           yhid:this.userInfo.yhid,
      //           gkfsxg:this.userInfo.gkfsxg,
      //           kl:this.userInfo.kl,
      //           zylb:this.zylb,
      //           gkfs:this.wscore,
      //           sssf:43,
      //           wscore:this.wscore,
      //           zscore:this.zscore,
      //           kl:this.sxkm,
      //           sxkm:this.sxkm,
      //           zxkm,
      //           zxkma,
      //           zxkmb,
      //           zcjd:this.userInfo.zcjd,
      //           yhlb:this.userInfo.yhlb,
      //           type:this.userInfo.type||2,
      //           flag:"1"
      //         })
      //         if (result.data.code === 200) {
      //           // const zylbs = await this.$http.getHttp("/users/updateLB?lb="+this.zylb);
      //           // if(zylbs.data.code===200){
      //           //   //如果修改成功要从新获取用户信息
      //           //   // this.$store.dispatch("initUserInfo", this.userInfo.uid);
      //           //   await this.getUser();
      //           //   //清空已存在的院校查询和推荐数据
      //           //   this.$store.dispatch("RestSchoolData");
      //           //   //重新计算综合分
      //           //   this._totalScore(this.userInfo.zylb, this.wscore, this.zscore);
      //           //   this.$message({
      //           //     type: "success",
      //           //     message: "修改成功",
      //           //     duration: "2000",
      //           //   });
      //           //   this.$router.push("/main/yshMe/updateScore?isload=true&&time="+new Date().getMilliseconds().toString());
      //           //   location.reload();
      //           //   return;
      //           // }else if(zylbs.data.code===500){
      //           //   if(zylbs.data.message){
      //           //       this.$message({message:zylbs.data.message,type:'error'});
      //           //   }else if(zylbs.data.msg){
      //           //       this.$message({message:zylbs.data.msg,type:"error"});
      //           //   }
      //           // }else if(zylbs.status===401){
      //           //       this.$message({message: '登录超时，请重新登录',type:"error"});
      //           //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //           //       this.$router.replace({
      //           //           path: '/main/home',
      //           //           query: {redirect: this.$router.currentRoute.fullPath}
      //           //       });
      //           // }else if(zylbs.data.code===0){
      //           //       this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
      //           //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //           //       this.$router.replace({
      //           //           path: '/main/home',
      //           //           query: {redirect: this.$router.currentRoute.fullPath}
      //           //       });
      //           // }else if(zylbs.status===409||zylbs.status===410||zylbs.status===411){
      //           //       this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
      //           //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //           //       this.$router.replace({
      //           //           path: '/main/home',
      //           //           query: {redirect: this.$router.currentRoute.fullPath}
      //           //       });
      //           // }else{
      //           //   this.$message({type:'error',message:'修改失败',duration:'2000'})
      //           // }
      //           //重新计算综合分
      //           this._totalScore(this.userInfo.zylb, this.wscore, this.zscore);
      //           //如果修改成功要从新获取用户信息
      //           // this.$store.dispatch("initUserInfo", this.userInfo.uid);
      //           await this.getUser();
      //           //清空已存在的院校查询和推荐数据
      //           this.$store.dispatch("RestSchoolData");
      //           this.$message({
      //             type: "success",
      //             message: "修改成功",
      //             duration: "2000",
      //           });
      //           this.$router.push("/main/yshMe/updateScore?isload=true&&time="+new Date().getMilliseconds().toString());
      //           location.reload();
      //           return;
      //         }else if(result.data.code===500){
      //           if(result.data.message){
      //               this.$message({message:result.data.message,type:'error'});
      //           }else if(result.data.msg){
      //             this.$message({message:result.data.message,type:'error'});
      //           }
      //         }else if(result.status===401){
      //               this.$message({message: '登录超时，请重新登录',type:"error"});
      //               await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //               this.$router.replace({
      //                   path: '/main/home',
      //                   query: {redirect: this.$router.currentRoute.fullPath}
      //               });
      //         }else if(result.data.code===0){
      //               this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
      //               await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //               this.$router.replace({
      //                   path: '/main/home',
      //                   query: {redirect: this.$router.currentRoute.fullPath}
      //               });
      //         }else if(result.status===409||result.status===410||result.status===411){
      //               this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
      //               await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //               this.$router.replace({
      //                   path: '/main/home',
      //                   query: {redirect: this.$router.currentRoute.fullPath}
      //               });
      //         }
      //       })
      //       .catch(() => {});
      // } else {
      //   if (!this.wscore) {
      //     this.$message({
      //       type: "error",
      //       message: "请输入文化成绩",
      //       duration: "2000",
      //     });
      //     return;
      //   } else if (!this.zscore) {
      //     this.$message({
      //       type: "error",
      //       message: "请输入专业成绩",
      //       duration: "2000",
      //     });
      //     return;
      //   } else if (zxkm.length < 2) {
      //     this.$message({
      //       type: "error",
      //       message: "请选择两项科目",
      //       duration: "2000",
      //     });
      //     return;
      //   }else if(!this.sxkm){
      //     this.$message({
      //       type: "error",
      //       message: "请选择首选科目",
      //       duration: "2000",
      //     });
      //     return;
      //   }else if(!this.zylb){
      //     this.$message({
      //       type: "error",
      //       message: "请选择专业类别",
      //       duration: "2000",
      //     });
      //     return;
      //   } else {
      //     // const result = await updateScore(
      //     //   this.userInfo.uid,
      //     //   this.userInfo.frequency,
      //     //   this.userInfo.kl,
      //     //   this.userInfo.zylb,
      //     //   this.wscore,
      //     //   this.zscore,
      //     //   zxkm
      //     // );
      //     if (!this.wscore) {
      //     this.$message({
      //       type: "error",
      //       message: "请输入文化成绩",
      //       duration: "2000",
      //     });
      //     return;
      //     } else if (!this.zscore) {
      //       this.$message({
      //         type: "error",
      //         message: "请输入专业成绩",
      //         duration: "2000",
      //       });
      //       return;
      //     } else if (zxkm.length < 2) {
      //       this.$message({
      //         type: "error",
      //         message: "请选择两项科目",
      //         duration: "2000",
      //       });
      //       return;
      //     }else if(!this.sxkm){
      //       this.$message({
      //         type: "error",
      //         message: "请选择首选科目",
      //         duration: "2000",
      //       });
      //       return;
      //     }else if(!this.zylb){
      //       this.$message({
      //         type: "error",
      //         message: "请选择专业类别",
      //         duration: "2000",
      //       });
      //       return;
      //     }
      //     const result=await this.$http.postHttp("/users/modifyFs",{
      //           yhid:this.userInfo.yhid,
      //           gkfsxg:this.userInfo.gkfsxg,
      //           kl:this.userInfo.kl,
      //           zylb:this.zylb,
      //           gkfs:this.wscore,
      //           sssf:43,
      //           wscore:this.wscore,
      //           zscore:this.zscore,
      //           kl:this.sxkm,
      //           sxkm:this.sxkm,
      //           zxkm,
      //           zxkma,
      //           zxkmb,
      //           zcjd:this.userInfo.zcjd,
      //           yhlb:this.userInfo.yhlb,
      //           type:this.userInfo.type||2,
      //           flag:"1"
      //         })
      //         if (result.data.code === 200) {
      //             // const zylbs = await this.$http.getHttp("/users/updateLB?lb="+this.zylb);
      //             // if(zylbs.data.code===200){
      //             //   //如果修改成功要从新获取用户信息
      //             //   // this.$store.dispatch("initUserInfo", this.userInfo.uid);
      //             //   await this.getUser();
      //             //   //清空已存在的院校查询和推荐数据
      //             //   this.$store.dispatch("RestSchoolData");
      //             //   //重新计算综合分
      //             //   this._totalScore(this.userInfo.zylb, this.wscore, this.zscore);
      //             //   this.$message({
      //             //     type: "success",
      //             //     message: "修改成功",
      //             //     duration: "2000",
      //             //   });
      //             //   this.$router.push("/main/yshMe/updateScore?isload=true&&time="+new Date().getMilliseconds().toString());
      //             //   location.reload();
      //             //   return;
      //             // }else if(zylbs.data.code===500){
      //             //   if(zylbs.data.message){
      //             //       this.$message({message:zylbs.data.message,type:'error'});
      //             //   }else if(zylbs.data.msg){
      //             //       this.$message({message:zylbs.data.msg,type:"error"});
      //             //   }
      //             // }else if(zylbs.status===401){
      //             //       this.$message({message: '登录超时，请重新登录',type:"error"});
      //             //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //             //       this.$router.replace({
      //             //           path: '/main/home',
      //             //           query: {redirect: this.$router.currentRoute.fullPath}
      //             //       });
      //             // }else if(zylbs.data.code===0){
      //             //       this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
      //             //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //             //       this.$router.replace({
      //             //           path: '/main/home',
      //             //           query: {redirect: this.$router.currentRoute.fullPath}
      //             //       });
      //             // }else if(zylbs.status===409||zylbs.status===410||zylbs.status===411){
      //             //       this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
      //             //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //             //       this.$router.replace({
      //             //           path: '/main/home',
      //             //           query: {redirect: this.$router.currentRoute.fullPath}
      //             //       });
      //             // }else{
      //             //   this.$message({type:'error',message:'修改失败',duration:'2000'})
      //             // }
      //             //如果修改成功要从新获取用户信息
      //             // this.$store.dispatch("initUserInfo", this.userInfo.uid);
      //             await this.getUser();
      //             //清空已存在的院校查询和推荐数据
      //             this.$store.dispatch("RestSchoolData");
      //             //重新计算综合分
      //             this._totalScore(this.userInfo.zylb, this.wscore, this.zscore);
      //             this.$message({
      //               type: "success",
      //               message: "修改成功",
      //               duration: "2000",
      //             });
      //             this.$router.push("/main/yshMe/updateScore?isload=true&&time="+new Date().getMilliseconds().toString());
      //             location.reload();
      //             return;
      //         }else if(result.data.code===500){
      //           if(result.data.message){
      //               this.$message({message:result.data.message,type:'error'});
      //           }else if(result.data.msg){
      //             this.$message({message:result.data.message,type:'error'});
      //           }
      //         }else if(result.status===401){
      //               this.$message({message: '登录超时，请重新登录',type:"error"});
      //               await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //               this.$router.replace({
      //                   path: '/main/home',
      //                   query: {redirect: this.$router.currentRoute.fullPath}
      //               });
      //         }else if(result.data.code===0){
      //               this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
      //               await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //               this.$router.replace({
      //                   path: '/main/home',
      //                   query: {redirect: this.$router.currentRoute.fullPath}
      //               });
      //         }else if(result.status===409||result.status===410||result.status===411){
      //               this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
      //               await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
      //               this.$router.replace({
      //                   path: '/main/home',
      //                   query: {redirect: this.$router.currentRoute.fullPath}
      //               });
      //         }
      //   }
      // }
      if (this.miaoshu==='分数修改次数已经用完！') {
        this.$message({
          type: "error",
          message: "抱歉，您的分数修改次数已用完，暂不可修改",
          duration: "2000",
        });
        return;
      }else if (this.miaoshu === '1次') {
          this.$confirm("分数修改仅剩一次机会，您确定修改吗？", "提示", {
            type: "warning",
          })
            .then(async () => {
              // const result = await updateScore(
              //   this.userInfo.uid,
              //   this.userInfo.frequency,
              //   this.userInfo.kl,
              //   this.userInfo.zylb,
              //   this.wscore,
              //   this.zscore,
              //   zxkm
              // );
              if (!this.wscore) {
          this.$message({
            type: "error",
            message: "请输入文化成绩",
            duration: "2000",
          });
          return;
              } else if (!this.zscore) {
                this.$message({
                  type: "error",
                  message: "请输入专业成绩",
                  duration: "2000",
                });
                return;
              } else if (zxkm.length < 2) {
                this.$message({
                  type: "error",
                  message: "请选择两项科目",
                  duration: "2000",
                });
                return;
              }else if(!this.sxkm){
                this.$message({
                  type: "error",
                  message: "请选择首选科目",
                  duration: "2000",
                });
                return;
              }else if(!this.zylb){
                this.$message({
                  type: "error",
                  message: "请选择专业类别",
                  duration: "2000",
                });
                return;
              }
              const result=await this.$http.postHttp("/users/modifyFs",{
                yhid:this.userInfo.yhid,
                gkfsxg:this.userInfo.gkfsxg,
                kl:this.userInfo.kl,
                zylb:this.zylb,
                gkfs:this.wscore,
                sssf:43,
                wscore:this.wscore,
                zscore:this.zscore,
                kl:this.sxkm,
                sxkm:this.sxkm,
                zxkm,
                zxkma,
                zxkmb,
                yfjf:this.yfjf,
                bz:this.userBz,
                zcjd:this.userInfo.zcjd,
                yhlb:this.userInfo.yhlb,
                type:this.userInfo.type||2,
                ywcj:this.ywcj,
                sxcj:this.sxcj,
                wycj:this.wycj,
                flag:"1"
              });
              if (result.data.code === 200) {
                // const zylbs = await this.$http.getHttp("/users/updateLB?lb="+this.zylb);
                // if(zylbs.data.code===200){
                //   //如果修改成功要从新获取用户信息
                //   // this.$store.dispatch("initUserInfo", this.userInfo.uid);
                //   await this.getUser();
                //   //清空已存在的院校查询和推荐数据
                //   this.$store.dispatch("RestSchoolData");
                //   //重新计算综合分
                //   this._totalScore(this.userInfo.zylb, this.wscore, this.zscore);
                //   this.$message({
                //     type: "success",
                //     message: "修改成功",
                //     duration: "2000",
                //   });
                //   this.$router.push("/main/yshMe/updateScore?isload=true&&time="+new Date().getMilliseconds().toString());
                //   location.reload();
                //   return;
                // }else if(zylbs.data.code===500){
                //   if(zylbs.data.message){
                //       this.$message({message:zylbs.data.message,type:'error'});
                //   }else if(zylbs.data.msg){
                //       this.$message({message:zylbs.data.msg,type:"error"});
                //   }
                // }else if(zylbs.status===401){
                //       this.$message({message: '登录超时，请重新登录',type:"error"});
                //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                //       this.$router.replace({
                //           path: '/main/home',
                //           query: {redirect: this.$router.currentRoute.fullPath}
                //       });
                // }else if(zylbs.data.code===0){
                //       this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                //       this.$router.replace({
                //           path: '/main/home',
                //           query: {redirect: this.$router.currentRoute.fullPath}
                //       });
                // }else if(zylbs.status===409||zylbs.status===410||zylbs.status===411){
                //       this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                //       this.$router.replace({
                //           path: '/main/home',
                //           query: {redirect: this.$router.currentRoute.fullPath}
                //       });
                // }else{
                //   this.$message({type:'error',message:'修改失败',duration:'2000'})
                // }
                //重新计算综合分
                this._totalScore(this.userInfo.zylb, this.wscore, this.zscore);
                //如果修改成功要从新获取用户信息
                // this.$store.dispatch("initUserInfo", this.userInfo.uid);
                await this.getUser();
                //清空已存在的院校查询和推荐数据
                this.$store.dispatch("RestSchoolData");
                this.$message({
                  type: "success",
                  message: "修改成功",
                  duration: "2000",
                });
                this.$router.push("/main/yshMe/updateScore?isload=true&&time="+new Date().getMilliseconds().toString());
                location.reload();
                return;
              }else if(result.data.code===500){
                if(result.data.message){
                    this.$message({message:result.data.message,type:'error'});
                }else if(result.data.msg){
                  this.$message({message:result.data.message,type:'error'});
                }
              }else if(result.status===401){
                    this.$message({message: '登录超时，请重新登录',type:"error"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }else if(result.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }else if(result.status===409||result.status===410||result.status===411){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }
            })
            .catch(() => {});
      } else {
        if (!this.wscore) {
          this.$message({
            type: "error",
            message: "请输入文化成绩",
            duration: "2000",
          });
          return;
        } else if (!this.zscore) {
          this.$message({
            type: "error",
            message: "请输入专业成绩",
            duration: "2000",
          });
          return;
        } else if (zxkm.length < 2) {
          this.$message({
            type: "error",
            message: "请选择两项科目",
            duration: "2000",
          });
          return;
        }else if(!this.sxkm){
          this.$message({
            type: "error",
            message: "请选择首选科目",
            duration: "2000",
          });
          return;
        }else if(!this.zylb){
          this.$message({
            type: "error",
            message: "请选择专业类别",
            duration: "2000",
          });
          return;
        } else {
          // const result = await updateScore(
          //   this.userInfo.uid,
          //   this.userInfo.frequency,
          //   this.userInfo.kl,
          //   this.userInfo.zylb,
          //   this.wscore,
          //   this.zscore,
          //   zxkm
          // );
          if (!this.wscore) {
          this.$message({
            type: "error",
            message: "请输入文化成绩",
            duration: "2000",
          });
          return;
          } else if (!this.zscore) {
            this.$message({
              type: "error",
              message: "请输入专业成绩",
              duration: "2000",
            });
            return;
          } else if (zxkm.length < 2) {
            this.$message({
              type: "error",
              message: "请选择两项科目",
              duration: "2000",
            });
            return;
          }else if(!this.sxkm){
            this.$message({
              type: "error",
              message: "请选择首选科目",
              duration: "2000",
            });
            return;
          }else if(!this.zylb){
            this.$message({
              type: "error",
              message: "请选择专业类别",
              duration: "2000",
            });
            return;
          }
          const result=await this.$http.postHttp("/users/modifyFs",{
                yhid:this.userInfo.yhid,
                gkfsxg:this.userInfo.gkfsxg,
                kl:this.userInfo.kl,
                zylb:this.zylb,
                gkfs:this.wscore,
                sssf:43,
                wscore:this.wscore,
                zscore:this.zscore,
                kl:this.sxkm,
                sxkm:this.sxkm,
                zxkm,
                zxkma,
                zxkmb,
                yfjf:this.yfjf,
                bz:this.userBz,
                zcjd:this.userInfo.zcjd,
                yhlb:this.userInfo.yhlb,
                type:this.userInfo.type||2,
                ywcj:this.ywcj,
                sxcj:this.sxcj,
                wycj:this.wycj,
                flag:"1"
              })
              if (result.data.code === 200) {
                  // const zylbs = await this.$http.getHttp("/users/updateLB?lb="+this.zylb);
                  // if(zylbs.data.code===200){
                  //   //如果修改成功要从新获取用户信息
                  //   // this.$store.dispatch("initUserInfo", this.userInfo.uid);
                  //   await this.getUser();
                  //   //清空已存在的院校查询和推荐数据
                  //   this.$store.dispatch("RestSchoolData");
                  //   //重新计算综合分
                  //   this._totalScore(this.userInfo.zylb, this.wscore, this.zscore);
                  //   this.$message({
                  //     type: "success",
                  //     message: "修改成功",
                  //     duration: "2000",
                  //   });
                  //   this.$router.push("/main/yshMe/updateScore?isload=true&&time="+new Date().getMilliseconds().toString());
                  //   location.reload();
                  //   return;
                  // }else if(zylbs.data.code===500){
                  //   if(zylbs.data.message){
                  //       this.$message({message:zylbs.data.message,type:'error'});
                  //   }else if(zylbs.data.msg){
                  //       this.$message({message:zylbs.data.msg,type:"error"});
                  //   }
                  // }else if(zylbs.status===401){
                  //       this.$message({message: '登录超时，请重新登录',type:"error"});
                  //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                  //       this.$router.replace({
                  //           path: '/main/home',
                  //           query: {redirect: this.$router.currentRoute.fullPath}
                  //       });
                  // }else if(zylbs.data.code===0){
                  //       this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                  //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                  //       this.$router.replace({
                  //           path: '/main/home',
                  //           query: {redirect: this.$router.currentRoute.fullPath}
                  //       });
                  // }else if(zylbs.status===409||zylbs.status===410||zylbs.status===411){
                  //       this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
                  //       await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                  //       this.$router.replace({
                  //           path: '/main/home',
                  //           query: {redirect: this.$router.currentRoute.fullPath}
                  //       });
                  // }else{
                  //   this.$message({type:'error',message:'修改失败',duration:'2000'})
                  // }
                  //如果修改成功要从新获取用户信息
                  // this.$store.dispatch("initUserInfo", this.userInfo.uid);
                  await this.getUser();
                  //清空已存在的院校查询和推荐数据
                  this.$store.dispatch("RestSchoolData");
                  //重新计算综合分
                  this._totalScore(this.userInfo.zylb, this.wscore, this.zscore);
                  this.$message({
                    type: "success",
                    message: "修改成功",
                    duration: "2000",
                  });
                  this.$router.push("/main/yshMe/updateScore?isload=true&&time="+new Date().getMilliseconds().toString());
                  location.reload();
                  return;
              }else if(result.data.code===500){
                if(result.data.message){
                    this.$message({message:result.data.message,type:'error'});
                }else if(result.data.msg){
                  this.$message({message:result.data.message,type:'error'});
                }
              }else if(result.status===401){
                    this.$message({message: '登录超时，请重新登录',type:"error"});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }else if(result.data.code===0){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }else if(result.status===409||result.status===410||result.status===411){
                    this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                    await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                    this.$router.replace({
                        path: '/main/home',
                        query: {redirect: this.$router.currentRoute.fullPath}
                    });
              }
        }
      }
    },
    async getApiIndexMethod(){
                const flag=this.$apiFlag;
                if(flag===1||flag===3){
                    this.module=await import("../../../api/index");
                }else if(flag===2){
                    this.module=await import("../../../api/index22");
                }
    },
            // 获取用户信息
    async getUser(){
        const res=await this.$http.getHttp("/users/getUserInfo?username="+this.userInfo.username);
        if(res.status===200){
            if(res.data.code===0){
                this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
                this.$router.replace({
                    path: '/main/home',
                    query: {redirect: this.$router.currentRoute.fullPath}
                });
            }else if(res.data.code===500){
                if(res.data.message){
                    this.$message({message:res.data.message,type:'error'});
                }
            }else{
                this.$store.dispatch("saveUserInfo",res.data);
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
    //初始化分数提示信息
    _init_frequency() {
      if (this.userInfo.gkfsxg === 0) {
        this.tip = "您的分数和科目修改次数为无限次";
      } else if (this.userInfo.gkfsxg === 1) {
        this.tip = "您的分数和科目修改仅剩1次修改机会";
      } else if (this.userInfo.gkfsxg === 2) {
        this.tip = "您的分数和科目修改次数已用完，暂不可修改";
      }
    },
    //动态计算当年综合分
    _totalScore(lb, wscore, zscore) {
      //编导，播音与主持，摄影摄像
      let totalScore = 0;
      if ( lb == "播音与主持类") {
        totalScore = Number(wscore) + Number(zscore);
        this.$store.dispatch("saveTatalScore", totalScore);
      } else {
        totalScore = (wscore * 0.3 + zscore * 0.7).toFixed(1);
        this.$store.dispatch("saveTatalScore", totalScore);
      }
    },
    // 再选科目选择
    choose_zxkm(val) {
      this.checked_zxkm = val;
    },
    async _initZylb(){
      let zyResult = await this.module.getZyTypes();
      if(zyResult.data.code === 200){
        this.zylbOptions = zyResult.data.data;
      }
    },
    async changeZy(lb){
      const a=true;
      if(a){
        return;
      }
      const zylbs = await this.$http.getHttp("/users/updateLB?lb="+lb);
      if(zylbs.data.code === 200){
        await this.getUser();
        this.$store.dispatch("RestSchoolData");
        this._totalScore(lb);
      }else if(zylbs.data.code===500){
            if(zylbs.data.message){
                this.$message({message:zylbs.data.message,type:'error'});
            }else if(zylbs.data.msg){
                this.$message({message:zylbs.data.msg,type:"error"});
            }
      }else if(zylbs.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(zylbs.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else if(zylbs.status===409||zylbs.status===410||zylbs.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:"warning"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
      }else{
        this.$message({type:'error',message:'修改失败',duration:'2000'})
      }  
    },
    
    // 获取修改次数
    async getUpdateNum(){
        const res=await this.$http.getHttp("/users/getModifFsCs");
        if(res.data.code===200){
            this.miaoshu=res.data.obj.miaoshu;
        }else if(res.data.code===500){
            if(res.data.message){
                this.$message({message:res.data.message,type:"error"});
            }
        }else if(res.status===401){
            this.$message({message: '登录超时，请重新登录',type:"error"});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            this.$message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.$store.dispatch("loginOut",{sjhm:this.userInfo.sjhm});
            this.$router.replace({
                path: '/main/home',
                query: {redirect: this.$router.currentRoute.fullPath}
            });
        }
    },
  },
  async mounted() {
    await this.getApiIndexMethod();
    this._init_frequency();
    const { wscore, zscore, zxkma, zxkmb,sxkm,zylb, yfjf, bz,ywcj,sxcj,wycj } = this.userInfo;
    this.wscore = wscore;
    this.zscore = zscore;
    if (!zxkma || !zxkmb) {
      this.checked_zxkm = [1, 2];
    } else {
      this.checked_zxkm = [zxkma, zxkmb];
    }
    if(sxkm>0){
      this.sxkm=sxkm;
    }
    if(zylb){
      this.zylb=zylb;
    }
    if(yfjf>=0){
      this.yfjf=yfjf;
    }
    if(bz){
      this.userBz=bz;
    }
    if(ywcj){
      this.ywcj=ywcj;
    }
    if(sxcj){
      this.sxcj=sxcj;
    }
    if(wycj){
      this.wycj=wycj;
    }
    await this._initZylb();
    await this.getUpdateNum();
  },
  watch: {
    userInfo() {
      this.$nextTick(() => {
        //监听只要分数修改了，就判断分数修改次数
        this._init_frequency();
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.update-pwd
    margin-left 30px
    min-height calc(100vh - 380px)
    min-height -moz-calc(100vh - 380px)
    min-height -webkit-calc(100vh - 380px)
    background-color #ffffff
    .title
        width 100%
        height 35px
        box-sizing border-box
        padding-left 10px
        line-height 35px
        font-size 15px
        font-weight bold
        color #2F4056
        background-color #D3D3D3
    .user-info
        box-sizing border-box
        padding 15px 30px
        font-size 15px
        color #606266
        h4
            margin 5px 0
        .info-top
            display flex
            align-items center
            flex-wrap wrap
            box-sizing border-box
            padding 15px 0
            border-top 1px solid #EBEEF5
            span
                width 30%
                margin-bottom 10px
                font-size 14px
                color #606266
                strong
                    font-weight 500
                    color #409EFF
        .info-bottom
            margin-top 30px
            h4
               padding-bottom 10px
               margin-bottom 20px
               border-bottom 1px solid #EBEEF5
            .score-panel
                padding-bottom 20px
                font-size 14px
                color #666
                span:nth-child(2), .store-btn
                    margin-left 30px
                input
                    box-sizing border-box
                    height 30px
                    border-radius 5px
                    padding-left 10px
                    outline none
                    border 1px solid #DCDFE6
                    transition all 0.5s
                    color #303133
                    &:focus
                        border 1px solid #409EFF
                        box-shadow 0 0 3px #409EFF
            .score-item, .subject-item
                margin-bottom 20px
            .subject-item
                display flex
                align-items center
            .tip-panel
                margin-top 15px
                padding 10px 0
                border 1px dashed #FF4500
                border-radius 5px
                font-size 14px
                text-align center
                color #FF4500
</style>
<style scoped>

h1,h2,h3,h4,h5,h6{
    margin: 0 !important;
    font-weight: 700 !important;
}
.update-pwd .user-info .info-bottom h4{
  margin-bottom: 20px !important;
}
.update-pwd .user-info h4{
  margin:5px 0 !important;
}
.specialSubjectItem{
  display:flex;
  align-items:center;
  justify-content:space-between;
}
.specialInput{
                box-sizing: border-box;
              height: 30px;
              border-radius: 5px;
              padding-left: 10px;
              outline: none;
              border: 1px solid #dcdfe6;
              transition: all 0.5s;
              color: #303133;box-sizing: border-box;
              height: 30px;
              border-radius: 5px;
              padding-left: 10px;
              outline: none;
              border: 1px solid #dcdfe6;
              transition: all 0.5s;
              color: #303133;
}
</style>
